<script setup lang="ts">
import { useTranslation } from 'i18next-vue'

const { t } = useTranslation()
</script>
<template>
    <p
        class="text-xs text-neutral-600 flex gap-2 items-center shortcut-hint"
        data-testid="press-enter-key-to-proceed"
    >
        <kbd class="not-italic font-sans">
            {{ t('ui.common.pressEnterKey') }}
        </kbd>
        <i class="bp-icons bp-enter" aria-hidden="true" />
    </p>
</template>
<style scoped>
.shortcut-hint {
    display: inline-flex;
}

@media (pointer: coarse), (max-width: 640px) {
    .shortcut-hint {
        display: none;
    }
}
</style>
